var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCoMobileinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.73 44.73"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Grupo 17"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Elipse 3",
    cx: 22.36,
    cy: 22.36,
    r: 22.36,
    fill: "#273475"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 32.16H15.68V10.5H29zm-7.72 2.2a1.07 1.07 0 111.07 1.08 1.07 1.07 0 01-1.07-1.08m8.62 1v-26a1.08 1.08 0 00-1.04-1.06h-13a1.09 1.09 0 00-1.08 1.08v26a1.07 1.07 0 001.09 1.05h13a1.06 1.06 0 001.06-1.05",
    fill: "#fff",
    "data-name": "Livello 12"
  }))))));
}

export default SvgCoMobileinline;